import { Box, ButtonBase, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import { Recipe } from '@shared/models/recipe.model';
import { isDeletedRecipe } from '@shared/helpers/recipe.helpers';
import { HeaderTextBox } from './HeaderTextBox';
import { EllipsisText } from '@ui/EllipsisText';
import { DropdownIndicator } from '@ui/DropdownIndicator';

type RecipeSelectorButtonProps = {
  onClick: () => void;
  recipe: Recipe | undefined;
  isRecipeDefined: boolean;
  isEdited: boolean;
  disabled: boolean;
};

const useStyles = makeStyles()(() => ({
  deletedName: {
    textDecoration: 'line-through',
  },
}));

export const RecipeSelectorButton: React.FC<RecipeSelectorButtonProps> = ({
  onClick,
  recipe,
  isRecipeDefined,
  isEdited,
  disabled,
}) => {
  const { classes } = useStyles();
  const textColor = isRecipeDefined ? undefined : 'text.subtle';
  const isDeleted = recipe ? isDeletedRecipe(recipe) : false;
  return (
    <ButtonBase
      focusRipple
      onClick={onClick}
      sx={{
        textTransform: 'none',
        borderRadius: (theme) => `${theme.shape.borderRadius}px`,
        '&:hover': {
          backgroundColor: (theme) => theme.palette.action.hover,
        },
      }}
      disabled={disabled}
    >
      <HeaderTextBox>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Tooltip
            title={
              isDeleted ? (
                <FormattedMessage
                  id="element_recipe.deleted_tooltip"
                  defaultMessage="This recipe has been deleted"
                />
              ) : (
                ''
              )
            }
            disableHoverListener={!isDeleted}
          >
            <Box
              sx={{
                display: 'inline-flex',
                overflow: 'hidden',
                minWidth: 0,
                alignItems: 'center',
              }}
            >
              <EllipsisText
                color={textColor}
                className={isDeleted ? classes.deletedName : undefined}
              >
                {recipe?.name ?? 'No recipe'}
              </EllipsisText>
            </Box>
          </Tooltip>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: textColor,
              gap: 1,
            }}
          >
            {isEdited && ' *'}
            <DropdownIndicator />
          </Box>
        </Box>
      </HeaderTextBox>
    </ButtonBase>
  );
};
